import request from '@/utils/request'

export function issueToBoard(data) {
 return request({
  url: '/sivadm/themeJson/autodownload',
  method: 'post',
  data,
 })
}

export function postThemeJson(gzippedData) {
    const blob = new Blob([gzippedData], {
      type: 'application/json'
    });
  
    return request({
      url: '/sivadm/themeJson',
      method: 'post',
      data: blob,
      headers: {
        'Content-Type': 'application/json',
        'Content-Encoding': 'gzip', // 可选，帮助后端识别
        'Accept': 'application/json'
      },
      responseType: 'json'
    });
  }
  
export function getThemeJson(guid) {
 return request({
  url: '/sivadm/themeJson/' + guid,
  method: 'get',
 })
}

export function getThemeByGuid(guid) {
 return request({
  url: '/theme',
  method: 'get',
  params: { guid },
 })
}

export function getThemeListOwn(openid) {
 return request({
  url: '/sivadm/user-theme/owned/' + openid,
  method: 'get',
 })
}

export function getThemeListCoop(openid) {
 return request({
  url: '/sivadm/user-theme/coop/' + openid,
  method: 'get',
 })
}

export function createOrModifyTheme(data) {
 return request({
  url: '/sivadm/theme',
  method: 'post',
  data,
 })
}

export function deleleTheme(data) {
 return request({
  url: '/sivadm/theme',
  method: 'delete',
  data,
 })
}

export function duplicate(data) {
 return request({
  url: '/sivadm/theme/duplicate',
  method: 'post',
  data,
 })
}
